import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
const listeners = new Set();

export const useStore = () => {
  const [settings, setSettings] = useState(cache);

  useEffect(() => {
    if (!cache) {
      api
        .get("/settings")
        .then(({ data }) => {
          cache = data;
          listeners.forEach((l) => l(data));
        })
        .catch(() => {});
    }
    listeners.add(setSettings);
    return () => listeners.delete(setSettings);
  }, []);

  return {
    settings,
    storeName: settings?.store_name || "Kumamoto Halal Food",
    address: settings?.address || "Kumamoto shi, Chuoku, Kurokami 5-5-10",
    phone: settings?.phone || "+819013459975",
    whatsappEnabled: settings?.whatsapp_float_enabled !== false,
    whatsappNumber: settings?.whatsapp_number || "",
    whatsappMessage: settings?.whatsapp_message || "",
    categoryOrder: settings?.category_order || [],
    categoryIcons: settings?.category_icons || {},
    featuredIds: settings?.featured_product_ids || [],
  };
};

export const refreshStore = async () => {
  const { data } = await api.get("/settings");
  cache = data;
  listeners.forEach((l) => l(data));
  return data;
};
